<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content">
        <el-form
          class="box"
          ref="salesTargetForm"
          :model="salesTarget"
          label-width="90px"
        >
          <fieldset class="mgb15">
            <legend>{{ $t("text.baseInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('salesTarget.month')">{{
                  salesTarget.month
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('salesTarget.target')">
                  <currency :code="salesTarget.currency"></currency
                  >{{ salesTarget.target }}</el-form-item
                >
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('salesTarget.complete')">
                  <currency
                    :code="salesTarget.currency"
                    v-if="salesTarget.complete != null"
                  ></currency
                  >{{ salesTarget.complete }}</el-form-item
                >
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('salesTarget.completeRate')">
                  <span v-if="salesTarget.complete != null">
                    <currency :code="salesTarget.currency"></currency
                    >{{
                      Util.toFixed(salesTarget.complete / salesTarget.target, 3)
                    }}</span
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset class="mgb15">
            <legend>{{ $t("salesTarget.detailInfo") }}</legend>
            <vxe-table
              :data="salesTargetItems"
              size="mini"
              border
              highlight-hover-row
            >
              <vxe-table-column
                field="userName"
                :title="$t('salesTarget.userName')"
              ></vxe-table-column>

              <vxe-table-column
                field="target"
                :title="$t('salesTarget.target')"
              >
                <template v-slot="{ row }">
                  <currency :code="salesTarget.currency"></currency>
                  {{ row.target }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="complete"
                :title="$t('salesTarget.complete')"
              >
                <template v-slot="{ row }">
                  <currency
                    :code="salesTarget.currency"
                    v-if="row.complete != null"
                  ></currency>
                  {{ row.complete }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="completeRate"
                :title="$t('salesTarget.completeRate')"
              >
                <template v-slot="{ row }">
                  <span
                    v-if="
                      row.complete != null &&
                      row.target != null &&
                      row.target != 0
                    "
                    >{{ Util.toFixed(row.complete / row.target, 3) }}</span
                  >
                </template>
              </vxe-table-column>
              <vxe-table-column
                v-if="Permit.canActionsChargeEdition('salesTargetManage')"
                field="action"
                :title="$t('text.action')"
                width="50"
              >
                <template v-slot="{ row }"
                  ><el-button type="text" size="mini" @click="deleteRow(row)">
                    {{ $t("text.delete") }}
                  </el-button>
                </template>
              </vxe-table-column>
            </vxe-table>
          </fieldset>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Currency from "@/components/Currency";
import SalesTarget from "@/api/salesTarget.js";
import SalesTargetItem from "@/api/salesTargetItem.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: { Currency },
  data() {
    return {
      Util: Util,
      salesTarget: { month: null },
      salesTargetItems: [],
    };
  },
  created() {
    const self = this;
    self.loadingStart();
    axios
      .all([
        SalesTarget.findById({ id: self.id }),
        SalesTargetItem.findBySalesTargetId({
          salesTargetId: self.id,
        }),
      ])
      .then(
        axios.spread(function (salesTarget, salesTargetItems) {
          if (salesTarget.data.code === 200) {
            self.salesTarget = salesTarget.data.entity;
            self.loadingEnd();
          } else {
            self.sysError();
          }
          if (salesTargetItems.status === 200) {
            self.salesTargetItems = salesTargetItems.data;
          } else {
            self.sysError();
          }
        })
      );
  },
  methods: {
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        SalesTargetItem.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    loadData() {
      const self = this;
      axios
        .all([
          SalesTarget.findById({ id: self.id }),
          SalesTargetItem.findBySalesTargetId({
            salesTargetId: self.id,
          }),
        ])
        .then(
          axios.spread(function (salesTarget, salesTargetItems) {
            if (salesTarget.data.code === 200) {
              self.salesTarget = salesTarget.data.entity;
            } else {
              self.sysError();
            }
            if (salesTargetItems.status === 200) {
              self.salesTargetItems = salesTargetItems.data;
            } else {
              self.sysError();
            }
          })
        );
    },
  },
};
</script>